"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
    General
    
    All general words from the ESN project
    
    Verified by: Cédric Bloem
    Date: 12/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
var General = {
  esn: {
    nl: 'osn',
    fr: 'rse',
    en: 'esn'
  },
  user: {
    nl: 'gebruiker',
    fr: 'utulisateur',
    en: 'user'
  },
  dutch: {
    nl: 'Nederlands',
    fr: 'Néerlandais',
    en: 'Dutch'
  },
  french: {
    nl: 'Frans',
    fr: 'Français',
    en: 'French'
  },
  english: {
    nl: 'Engels',
    fr: 'Anglais',
    en: 'English'
  },
  lang_short: {
    nl: 'nl',
    fr: 'fr',
    en: 'en'
  },
  group: {
    nl: 'Groep',
    fr: 'Groupe',
    en: 'Group'
  },
  not_group: {
    nl: 'Niet groep',
    fr: 'Pas de groupe',
    en: 'not group'
  },
  group_connections: {
    nl: 'Groepskoppelingen',
    fr: 'Connexions de groupe',
    en: 'Group connections'
  },
  groups: {
    nl: 'Groepen',
    fr: 'Groupes',
    en: 'Groups'
  },
  all_groups: {
    nl: 'Alle groepen',
    fr: 'Toutes les groupes',
    en: 'All groups'
  },
  cread: {
    nl: 'CREAD',
    fr: 'CREAD',
    en: 'CREAD'
  },
  creads: {
    nl: 'CREADs',
    fr: 'CREADs',
    en: 'CREADs'
  },
  all_creads: {
    nl: 'Alle CREADs',
    fr: 'Toutes les CREADs',
    en: 'All CREADs'
  },
  pages: {
    nl: "Pagina's",
    fr: 'Pages',
    en: 'Pages'
  },
  icon: {
    nl: 'Icoon',
    fr: 'Icône',
    en: 'Icon'
  },
  icons: {
    nl: 'Iconen',
    fr: 'Icônes',
    en: 'Icons'
  },
  media: {
    nl: 'Media',
    fr: 'Médias',
    en: 'Media'
  },
  search: {
    nl: 'Zoek naar...',
    fr: 'Chercher...',
    en: 'Search...'
  },
  search_and_add: {
    nl: 'Zoek en voeg toe...',
    fr: 'Rechercher et ajouter...',
    en: 'Search and add...'
  },
  profile_settings: {
    nl: 'Profiel instellingen',
    fr: 'Paramètres profil',
    en: 'Profile settings'
  },
  history: {
    nl: 'Geschiedenis',
    fr: 'Histoire',
    en: 'History'
  },
  notifications: {
    nl: 'Notificaties',
    fr: 'Les notifications',
    en: 'Notifications'
  },
  colleagues: {
    nl: "Collega's",
    fr: 'Collègues',
    en: 'Colleagues'
  },
  management: {
    nl: 'Beheer',
    fr: 'Administration',
    en: 'Management'
  },
  export_data: {
    nl: 'Exporteer gegevens',
    fr: 'Exporter des données',
    en: 'Export data'
  },
  add: {
    nl: 'Voeg toe',
    fr: 'Ajouter',
    en: 'Add'
  },
  media_library: {
    nl: 'Media bibliotheek',
    fr: 'Médiathèque',
    en: 'Media library'
  },
  all_icons: {
    nl: 'Alle iconen',
    fr: 'Toutes les icones',
    en: 'All icons'
  },
  all_media: {
    nl: 'Alle media',
    fr: 'Tous les médias',
    en: 'All media'
  },
  active: {
    nl: 'Actief',
    fr: 'Actif',
    en: 'Active'
  },
  is_active: {
    nl: 'Actief',
    fr: 'Actif',
    en: 'Active'
  },
  start_date: {
    nl: 'Begindatum',
    fr: 'Date de début',
    en: 'Start date'
  },
  end_date: {
    nl: 'Einddatum',
    fr: 'Date de fin',
    en: 'End date'
  },
  entity: {
    nl: 'Entiteit',
    fr: 'Entité',
    en: 'Entity'
  },
  update_date: {
    nl: 'Geüpdatet op',
    fr: 'Date mis à jour',
    en: 'Updated on'
  },
  created_date: {
    nl: 'Aanmaakdatum',
    fr: 'Date de création',
    en: 'Created date'
  },
  entity_info: {
    nl: 'Informatie over entiteit',
    fr: "Information d'entité",
    en: 'Entity information'
  },
  edit: {
    nl: 'Bewerk',
    fr: 'Éditer',
    en: 'Edit'
  },
  settings: {
    nl: 'Instellingen',
    fr: 'Paramètres',
    en: 'Settings'
  },
  draft: {
    nl: 'Klad',
    fr: 'Brouillon',
    en: 'Draft'
  },
  logo: {
    nl: 'Logo',
    fr: 'Logo',
    en: 'Logo'
  },
  name: {
    nl: 'Naam',
    fr: 'Nom',
    en: 'Name'
  },
  description: {
    nl: 'Beschrijving',
    fr: 'Description',
    en: 'Description'
  },
  describe_group: {
    nl: 'Beschrijf deze groep',
    fr: 'Décrire ce groupe',
    en: 'Describe this group'
  },
  confirm: {
    nl: 'Bevestigen',
    fr: 'Confirmer',
    en: 'Confirm'
  },
  delete_all: {
    nl: 'Verwijder alles',
    fr: 'Effacer tout',
    en: 'Remove all'
  },
  advanced_search: {
    nl: 'Geavanceerd zoeken',
    fr: 'Recherche avancée',
    en: 'Advanced search'
  },
  search_options: {
    nl: 'Zoekopties',
    fr: 'Options de recherche',
    en: 'Search options'
  },
  something_went_wrong: {
    nl: 'Er ging iets mis',
    fr: 'Quelque chose a mal tourné',
    en: 'Something went wrong'
  },
  no_current_offers: {
    nl: 'Er zijn geen huidige aanbiedingen',
    fr: "Il n'y a pas d'offres a montrer",
    en: 'There are no current offers'
  },
  current_offers: {
    nl: 'Huidige aanbiedingen',
    fr: 'Offres actuelles',
    en: 'Current offers'
  },
  in_the_picture: {
    nl: 'In de kijker',
    fr: "Mettre à l'honneur",
    en: 'In the picture'
  },
  business_page: {
    nl: 'Bedrijfspagina',
    fr: "Page d'entreprise",
    en: 'Business page'
  },
  video_library: {
    nl: 'Video bibliotheek',
    fr: 'Vidéothèque',
    en: 'Video library'
  },
  videos: {
    nl: "Video's",
    fr: 'Vidéos',
    en: 'Videos'
  },
  video: {
    nl: "Video",
    fr: 'Vidéo',
    en: 'Video'
  },
  promos_and_catalogues: {
    nl: "Promo's & catalogi",
    fr: 'Promos et catalogues',
    en: 'Promos & catalogues'
  },
  promos_and_magazines: {
    nl: "Promo's & magazines",
    fr: 'Promos et magazines',
    en: 'Promos & magazines'
  },
  brands: {
    nl: 'Merken',
    fr: 'Marques',
    en: 'Brands'
  },
  brand: {
    nl: 'Merk',
    fr: 'Marque',
    en: 'Brand'
  },
  manufacturers: {
    nl: 'Fabrikanten',
    fr: 'Fabricants',
    en: 'Manufacturers'
  },
  manufacturer: {
    nl: 'Fabrikant',
    fr: 'Fabricant',
    en: 'Manufacturer'
  },
  activites_and_services: {
    nl: 'Activiteiten & diensten',
    fr: 'Activités et services',
    en: 'Activities & services'
  },
  activities: {
    nl: 'Activiteiten',
    fr: 'Activités',
    en: 'Activities'
  },
  news_articles: {
    nl: 'Nieuwsartikelen',
    fr: 'Articles de presse',
    en: 'News Articles'
  },
  news_article: {
    nl: 'Nieuwsartikel',
    fr: 'Article de presse',
    en: 'News Article'
  },
  back_to_results: {
    nl: 'Terug naar resultaten',
    fr: 'Retour aux résultats',
    en: 'Back to results'
  },
  how_do_we_protect: {
    nl: 'Hoe beschermen wij jouw privacy?',
    fr: 'Comment protégeons-nous vos données?',
    en: 'How do we protect your privacy?'
  },
  support: {
    nl: 'Support',
    fr: 'Assistance',
    en: 'Support'
  },
  privacy_policy: {
    nl: 'Privacybeleid',
    fr: 'Charte de confidentialité',
    en: 'Privacy policy'
  },
  terms_and_conditions: {
    nl: 'Algemene voorwaarden',
    fr: 'Conditions générales',
    en: 'Terms & Conditions'
  },
  of: {
    nl: 'van',
    fr: 'de',
    en: 'of'
  },
  result: {
    nl: 'resultaat',
    fr: 'résultat',
    en: 'result'
  },
  results: {
    nl: 'resultaten',
    fr: 'résultats',
    en: 'results'
  },
  discover_more: {
    nl: 'Ontdek meer',
    fr: 'Découvrez plus',
    en: 'Discover more'
  },
  visit_site: {
    nl: 'Bezoek website',
    fr: 'Visitez notre site',
    en: 'Visit site'
  },
  your_search_results: {
    nl: 'Jouw zoekresultaten | Ondernemers & Shoppingnetwerk',
    fr: 'Vos résultats de recherche | Réseau Shopping & Entrepreneurs',
    en: 'Your search results | Entrepreneurs & Shoppingnetwork'
  },
  oh_no: {
    nl: 'Oh nee! We kunnen de pagina die je zoekt niet terugvinden =(',
    fr: 'Oh non! Nous ne pouvons pas trouver la page que vous recherchez =(',
    en: "Oh no! We can't find the page you're looking for =("
  },
  unknown_error: {
    nl: 'Er ging iets mis! Het ligt niet aan jou maar aan ons',
    fr: "Quelque chose s'est mal passé! Ce n'est pas à vous mais à nous",
    en: "Something went wrong! It's not you; it's us"
  },
  cant_find_results: {
    nl: 'Sorry! Er konden geen resultaten worden gevonden',
    fr: "Désoler! Aucun résultat n'a pu être trouvé",
    en: 'Sorry! No results could be found'
  },
  child_focus_lang: {
    nl: 'nl-BE',
    fr: 'fr-BE',
    en: 'en'
  },
  page: {
    nl: 'Pagina',
    fr: 'Page',
    en: 'Page'
  },
  firstname: {
    nl: 'Voornaam',
    fr: 'Prénom',
    en: 'First name'
  },
  lastname: {
    nl: 'Achternaam',
    fr: 'Nom',
    en: 'Last name'
  },
  how_to_bookmark: {
    nl: 'Druk op CTRL + D om toe te voegen aan bladwijzers',
    fr: 'Appuyez sur CTRL + D pour ajouter aux favoris',
    en: 'Press CTRL + D to add to bookmarks'
  },
  entrepreneur: {
    nl: 'Ondernemer',
    fr: 'Entrepreneur',
    en: 'Entrepreneur'
  },
  title: {
    nl: 'Title',
    fr: 'Titre',
    en: 'Title'
  },
  duration: {
    nl: 'Looptijd',
    fr: 'La durée',
    en: 'Duration'
  },
  am_sure: {
    nl: 'Ik ben zeker!',
    fr: 'Je suis sure!',
    en: 'I\'m sure!'
  },
  changed_my_mind: {
    nl: 'Ben van gedacht veranderd',
    fr: 'J\'ai changé d\'avis',
    en: 'I\ve changed my mind'
  },
  sure_you_want_to_delete: {
    nl: 'Ben je zeker dat je dit wilt verwijderen?',
    fr: 'Voulez-vous vraiment supprimer cela?',
    en: 'Are you sure you want to delete this?'
  },
  from: {
    nl: 'Van',
    fr: 'De',
    en: 'From'
  },
  to: {
    nl: 'Tot',
    fr: 'à',
    en: 'To'
  },
  no_linked: {
    nl: 'Geen gekoppelde',
    fr: 'Pas de lien',
    en: 'No linked'
  },
  selected: {
    nl: 'Geselecteerde',
    fr: 'Sélectionné',
    en: 'Selected'
  }
};
var _default = General;
exports["default"] = _default;